import React from "react";
import Header from "../../components/shared/header/header";
import Sidebar from "../../components/shared/sidebar/sidebar";
import CommunityForm from "../../components/community-patrol/community-patrol";
import { DEFAULT_SIDEBAR_OPEN } from "../../helpers/constants";

export default class MainCommunityPatrolContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isSidebarOpen: DEFAULT_SIDEBAR_OPEN
        }
    }
    render() {
        return (
            <div className="admin-content" style={{ display: 'flex' }}>
                <Header handleSidebar={() => this.setState({ isSidebarOpen: !this.state.isSidebarOpen })} {...this.props} />
                <Sidebar isSidebarOpen={this.state.isSidebarOpen} {...this.props}>
                    <CommunityForm {...this.props} />
                </Sidebar>
            </div>
        )
    }
}
